import React, { Component } from 'react'
import Pagination from 'react-js-pagination'
import * as MabnaButton from '../../Button/Button'
import { PulseLoader } from 'halogen'
import { connect } from 'react-redux'
import { NotificationManager } from 'react-notifications'
import Dialog from 'material-ui/Dialog'

import AddSingleStudentToSchool from './AddSingleStudentToSchool'
import AddStudentsFromExcel from './AddStudentsFromExcel'
import sampleGroupSignupDocument from '../../../../helpers/Students_List.xlsx'
import QueryAble from '../../../common/SearchAndQueryBar'
import { toPersianDigit } from '../../../../helpers/nums'
import styles from './styles'
import Toolbar from './Toolbar'

import {
  FETCH_SCHOOL_STUDENTS_REQUEST,
  FETCH_GRADES_REQUEST,
} from '../../../../actions/actions'

import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
} from 'material-ui/Table'

import {
  flattenArray,
  getErrors,
  translateProfileFields,
  uniq,
} from '../../../../helpers/utility'

/* Required Props
    onStudentSelection :: studentsList -> void,
    onAddStudentsClick :: selected -> void, (finished selecting),
    selected :: student[] (list of current selection)
    service,
    serviceTitle
*/

class ServiceStudentsSelector extends Component {
  state = {
    selected: [],
    showOnlySelectedStudents: false,
    addStudentModalIsOpen: false,
    pagination: {
      activePage: 1,
    },
    ignore_errors: false,
  }

  setIgnoreErrors = val => this.setState({ ignore_errors: val })

  handleShowOnlySelectedPageChange = index => {
    this.setState({
      pagination: {
        activePage: index,
      },
    })
  }

  // componentDidMount = () => {
  //   const {
  //     studentsOfSchool: { result: studentsList },
  //   } = this.props

  //   if (studentsList.length === 0) {
  //     this.fetchStudentsOfSchool()
  //   }

  //   if (this.props.grades.length === 0) {
  //     this.props.dispatch({ type: FETCH_GRADES_REQUEST })
  //   }
  // }

  // fetchStudentsOfSchool = () => {
  //   this.props.dispatch({
  //     type: FETCH_SCHOOL_STUDENTS_REQUEST,
  //     schoolId: this.props.schoolId,
  //   })
  // }

  handleRowClick = selected => {
    switch (selected) {
      case 'all':
        const { result } = this.props.studentsOfSchool
        this.props.onStudentSelection(result)
        break

      case 'none':
        this.props.onStudentSelection([])
        break

      default:
        // partial selection => it's already an array 🙋
        const students = selected.map(indexOfRow => this.getListOfStudents()[indexOfRow])
        this.props.onStudentSelection(students)
        break
    }
  }

  allListSelected = () => {
    const { result } = this.props.studentsOfSchool

    // NOTE: some students are not select able!
    const selectAbleStudents = result
      .map(this.getStudentById)
      .filter(this.isStudentSelectAble)

    // add students to local state which is used for presentation only
    this.addArrayOfStudentsToSelectedList(selectAbleStudents)

    // inform api consumers (there are 2 kinds: cellClick and onStudentSelection)
    // both should be called.
    const selectAbleStudentsIds = selectAbleStudents.map(student => student.id)
    this.props.onStudentSelection(selectAbleStudentsIds)
    if (this.props.onCellClick) this.props.onCellClick(selectAbleStudentsIds)
  }

  getStudentById = studentId => this.props.studentsOfSchool.entities.students[studentId]

  handleCellClick = indexOfRow => {
    const { onCellClick } = this.props

    if (this.state.showOnlySelectedStudents) {
      const student = this.state.selected[indexOfRow]
      this.removeStudentFromSelected(student, this.checkForPaginationAfterRemove)
      this.checkForPaginationAfterRemove()
      onCellClick && onCellClick(student.id)
    } else {
      const studentId = this.getListOfStudents()[indexOfRow]
      const student = this.getStudentById(studentId)
      this.addStudentsToSelectedList(student)
      onCellClick && onCellClick(studentId)
    }
  }

  checkForPaginationAfterRemove = () => {
    const { selected } = this.state

    const pagesCountAfterRemove = Math.ceil(selected.length / 10)
    if (pagesCountAfterRemove < this.state.pagination.activePage) {
      this.handleShowOnlySelectedPageChange(pagesCountAfterRemove)
    }
  }

  removeStudentFromSelected = (student, cb) => {
    const newState = {
      selected: this.removeStudentFromList(this.state.selected, student),
    }

    this.setState(newState, cb)
  }

  removeStudentFromList = (list, studentToRemove) =>
    list.filter(student => student.id !== studentToRemove.id)

  addStudentsToSelectedList = studentToChange => {
    const studentExists = Boolean(
      this.state.selected.find(student => student.id === studentToChange.id)
    )

    if (studentExists) {
      const newSelected = this.removeStudentFromList(this.state.selected, studentToChange)

      this.setState({ selected: newSelected })
      return
    }

    this.setState({ selected: [...this.state.selected, studentToChange] })
  }

  addArrayOfStudentsToSelectedList = studentsArray => {
    if (studentsArray && Array.isArray(studentsArray)) {
      const currentSelection = this.state.selected
      const newSelection = [...currentSelection, ...studentsArray]

      this.setState({
        selected: uniq(newSelection),
      })
    }
  }

  onAddStudentsClick = () => {
    const { selected, ignore_errors } = this.state
    this.props.onAddStudentsClick(selected, ignore_errors)
  }

  isRowSelected = studentId => this.props.selected.includes(studentId)

  openStudentRegistrationModal = () => {
    this.setState({
      addStudentModalIsOpen: true,
    })
  }

  closeModal = () => {
    this.setState({
      addStudentModalIsOpen: false,
    })
  }

  renderRegisterNewStudentModal = service => {
    const actions = [
      <MabnaButton.Primary
        outline
        className="floating-close-button"
        onClick={this.closeModal}
      >
        بستن
      </MabnaButton.Primary>,
    ]

    const schoolGrades = this.props.schoolProfile.education_level
      ? this.props.schoolProfile.education_level.grades
      : this.props.grades

    return (
      <Dialog
        title={`عضویت و ثبت نام دانش آموز در ${service.title}`}
        actions={actions}
        modal={false}
        autoScrollBodyContent
        open={this.state.addStudentModalIsOpen}
        onRequestClose={this.closeModal}
        actionsContainerClassName="modal-actions"
        contentClassName="fatemi-modal"
      >
        <h3>افزودن گروهی دانش آموزان</h3>

        <a href={sampleGroupSignupDocument} download>
          دریافت فایل نمونه جهت ثبت نام گروهی
        </a>

        <AddStudentsFromExcel
          onAddSuccess={this.registerStudentSuccess}
          schoolId={this.props.schoolId}
          notCollapsedInitially
          stackVertically
          allowedGrades={schoolGrades}
        />

        {/* <hr />

        <AddSingleStudentToSchool
          onAddSuccess={student => this.registerStudentSuccess(this.list(student))}
          allowedGrades={this.findSharedGrades(schoolGrades, service.grades)}
          allowedGender={this.props.schoolProfile.gender_group}
        /> */}
      </Dialog>
    )
  }

  // to find which grades are in both school and the event
  findSharedGrades = (schoolGrades, eventGradesIds) => {
    const sharedGrades = schoolGrades.filter(schoolGrade => {
      return eventGradesIds.includes(schoolGrade.id)
    })

    return sharedGrades.length > 0 ? sharedGrades : schoolGrades
  }

  list = (...args) => args

  registerStudentSuccess = (students, ignore_errors = false) => {
    if (!students) return

    // current selection + the newly added students
    // this.fetchStudentsOfSchool()

    // students can be an array of students or a single one
    if (Array.isArray(students)) {
      this.addArrayOfStudentsToSelectedList(students)
      this.props.onCellClick(students.map(student => student.id))
    } else {
      this.addStudentsToSelectedList(students)
      this.props.onCellClick(students.id || students)
    }

    // only show the newly added students to make it clearer for the user
    this.showOnlySelectedStudents()

    this.setIgnoreErrors(ignore_errors)
  }

  genderQueryOptions = {
    name: 'gender',
    label: 'جنسیت',
    options: [{ name: 'دختر', value: 'female' }, { name: 'پسر', value: 'male' }],
  }

  searchOptions = [
    { name: 'search', label: 'جستجو در نام' },
    { name: 'national_number', label: 'جستجو در کد ملی' },
  ]

  formatGradesQueryOptions = grades => {
    return {
      name: 'grade',
      label: 'پایه تحصیلی',
      options: grades.map(grade => ({
        name: grade.name,
        value: grade.id,
      })),
    }
  }

  generateQueryOptions = () => {
    const queryOptions = []

    queryOptions.push(this.formatGradesQueryOptions(this.getGradesOfTheSchool()))

    if (this.shouldShowGenderQuery()) {
      queryOptions.push(this.genderQueryOptions)
    }

    return queryOptions
  }

  shouldShowGenderQuery = () => {
    const { gender_group } = this.props.schoolProfile
    return gender_group === 'both'
  }

  getGradesOfTheSchool = () =>
    this.props.schoolProfile.education_level
      ? this.props.schoolProfile.education_level.grades
      : this.props.grades

  showOnlySelectedStudents = () => {
    this.setState({
      showOnlySelectedStudents: true,
    })
  }

  showAllStudents = () => {
    this.setState({
      showOnlySelectedStudents: false,
    })
  }

  renderFilterButtons = () => (
    <div className="button-container">
      {/* <MabnaButton.Primary
        disabled={this.props.selected.length === 0 || this.state.showOnlySelectedStudents}
        outline
        onClick={this.showOnlySelectedStudents}
      >
        <span>مشاهده انتخاب شده‌ها</span>
        <span> </span>
        <span>{`(${toPersianDigit(this.getSelectedStudentsCount())})`}</span>
      </MabnaButton.Primary> */}

      {/* <MabnaButton.Primary
        disabled={!this.state.showOnlySelectedStudents}
        outline
        onClick={this.showAllStudents}
      >
        مشاهده همه
      </MabnaButton.Primary> */}

      <MabnaButton.Primary outline onClick={this.openStudentRegistrationModal}>
        بارگزاری فایل دانش آموزان
      </MabnaButton.Primary>

      {/* <MabnaButton.Primary
        outline
        disabled={this.props.disabled}
        onClick={this.allListSelected}
      >
        انتخاب تمام صفحه
      </MabnaButton.Primary> */}
    </div>
  )

  getSelectedStudentsCount = () => this.props.selected.length

  renderTotalSelectedCount = () => {
    const studentsCount = this.getSelectedStudentsCount()
    if (studentsCount === 0) return <div />

    return (
      <div>
        <span>تعداد</span>
        <span> </span>
        <span>{toPersianDigit(studentsCount)}</span>
        <span> </span>
        <span>دانش آموز انتخاب شده است</span>
      </div>
    )
  }

  getArrayChunkByPageIndex = (list, stepSize, index) => {
    if (!list && !Array.isArray(list))
      throw new TypeError('list supplied to getArrayChunkByPageIndex is not a list')

    return list.slice((index - 1) * stepSize, index * stepSize)
  }

  getListOfStudents = () => {
    const {
      studentsOfSchool: { result },
    } = this.props

    // maintain the pagination, slice the array into 10 item
    if (this.state.showOnlySelectedStudents) {
      return this.getArrayChunkByPageIndex(
        this.state.selected,
        10,
        this.state.pagination.activePage
      )
    }

    return result
  }

  renderFooter = () => {
    // if there was no click handler for payment, dont render this
    if (!this.props.onAddStudentsClick) return <div />

    return (
      <div className="select-student-of-school__action-button">
        {this.renderTotalSelectedCount()}

        <MabnaButton.Primary
          onClick={this.onAddStudentsClick}
          disabled={this.state.selected.length === 0}
          style={{ marginRight: 10 }}
        >
          پرداخت و تکمیل ثبت نام
        </MabnaButton.Primary>
      </div>
    )
  }

  // just a hack to make table re-render
  tableBugWorkaround = 0

  getGradeName = gradeId => {
    const grade = this.props.grades.find(grade => grade.id === gradeId)
    return grade ? grade.name : ''
  }

  notifyUserWithErrors({ general_errors, form_errors }) {
    const errors = [...flattenArray(general_errors), ...getErrors(form_errors)]
    for (let error of errors) {
      NotificationManager.error(error, null, 6000)
    }
  }

  isStudentSelectAble = student => student.gender !== null

  render() {
    const {
      schoolId,
      service,
      studentsOfSchool: {
        entities: { students },
        count,
      },
      hideDynamicStudentSignup,
      serviceTitle,
    } = this.props

    // this just a hack to fix a bug in material-ui and force Table to re-rendering
    // this.tableBugWorkaround = this.tableBugWorkaround > 0 ? 0 : 1

    // const { showOnlySelectedStudents } = this.state
    // const areRowsSelectAble = !this.props.disabled

    return (
      <div>
          {this.props.aSyncCall ? (
            <div style={styles.spinner}>
              <PulseLoader color={'#00abde'} />
            </div>
          ) : (
            <div className="school-student-selector">
              <Toolbar serviceTitle={serviceTitle} />

              {/* {this.renderFilterButtons()} */}

              <div id="import-students-wrapper">
                <h3>افزودن گروهی دانش آموزان</h3>

                <a href={sampleGroupSignupDocument} download>
                  دریافت فایل نمونه جهت ثبت نام گروهی
                </a>

                <AddStudentsFromExcel
                  onAddSuccess={this.registerStudentSuccess}
                  schoolId={this.props.schoolId}
                  notCollapsedInitially
                  stackVertically
                />
              </div>

            </div>
          )}

          {this.renderFooter()}

        {/* {!hideDynamicStudentSignup && this.renderRegisterNewStudentModal(service)} */}
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    studentsOfSchool: state.school.students,
    schoolProfile: state.profile.userInfo,
    aSyncCall: state.school.schoolAsync,
    schoolId: state.auth.userId,
    grades: state.grades,
  }
}

export default connect(mapStateToProps)(ServiceStudentsSelector)



// WEBPACK FOOTER //
// ./src/components/common/Services/ServiceStudentsSelector/ServiceStudentsSelector.js